import React, { useState } from 'react';
import '../styles/TextBox.css';

const TextBox = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSendLink = () => {
        if (email) {
            setMessage(`A password reset link has been sent to your email: ${email}`);
        } else {
            setMessage('Please enter a valid email address.');
        }
    };

    return (
        <div className="example-page">
            {/* <h1>{type.replace(/-/g, ' ')}</h1> */}
          
                <div className="text-box-example">
                    <h2 className='forgot-heading'>Forgot Password</h2>
                    {/* <p>Enter your email below to receive a password reset link:</p> */}
                    E-mail
                    <input
                        type="text"
                        name="user_email"
                        id="email-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        // placeholder="Enter your email"
                        className="email-input"
                    />
                    <div className="send-button-wrapper">
                        <button
                            onClick={handleSendLink}
                            className="send-button"
                            id="form_submit"
                            name="get_password"
                            title="A password reset link will be sent to your email"
                            aria-describedby="retrieve-password-tooltip"
                        >
                            Reset Password
                        </button>
                        <span
                            className="send-button-tooltip"
                            id="retrieve-password-tooltip"
                            role="tooltip"
                        >
                            A password reset link will be sent to your email
                        </span>
                    </div>
                    {message && <p className="message">{message}</p>}
                </div>
            
        </div>
    );
};

export default TextBox;
